import React from 'react'

import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

import { useQuery } from '../models'
import AcceptsOnlineBookingFilter from './AcceptsOnlineBookingFilter'
import DistanceField from './DistanceField'
import MaybeLanguageField from './MaybeLanguageField'
import MaybePartnerTagsField from './MaybePartnerTagsField'
import MaybeSpecialtyField from './MaybeSpecialtyField'
import ShowAllLocationsButton from './ShowAllLocationsButton'

const FilterChipBar = () => {
  const { store } = useQuery()
  const theme = useTheme()
  const mobile = useMediaQuery(theme.breakpoints.down('md'))

  if (store.staticPage) {
    return null
  }
  return (
    <Box
      aria-label="Filter Bar"
      sx={{
        display: 'flex',
        gap: 1,
        flexWrap: 'nowrap',
        width: 'fit-content',
        pb: mobile ? 1 : 0,
        px: mobile ? 1.5 : 0,
        ...(mobile && {
          '& .MuiInputBase-root, & .MuiFormControlLabel-root': {
            height: 32,
            fontFamily: 'Qanelas, Arial, sans-serif',
            fontSize: 14,
            fontWeight: 400,
          },
          '& .MuiInputBase-root .MuiSelect-select': {
            height: 32,
            minHeight: 0,
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            py: 0,
            pl: '12px',
            pr: '28px',
            border: 0,
            color: '#003087',
            boxShadow: '0 2px 2px rgba(0,0,0,.25)',
          },
          '& .MuiFormControlLabel-root': {
            py: 0,
            border: 0,
            boxShadow: '0 2px 2px rgba(0,0,0,.25)',
          },
          '& .MuiFormControlLabel-label': {
            fontFamily: 'inherit',
            fontSize: 14,
            fontWeight: 400,
          },
        }),
      }}
    >
      <ShowAllLocationsButton />
      <DistanceField />
      <MaybeSpecialtyField />
      <MaybeLanguageField />
      <MaybePartnerTagsField />
      <AcceptsOnlineBookingFilter />
    </Box>
  )
}

export default FilterChipBar
